export const BROADCAST_CHANNEL_VIEWS = ['IN_APP', 'SMS', 'WHATSAPP'];
export class BroadcastApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** `POST /v1/broadcasts/preview` — the audience of a draft, market by market, with each market's policy. */
    preview(input) {
        return this.client.request({ method: 'POST', path: '/v1/broadcasts/preview', body: input, auth: true });
    }
    /** `POST /v1/broadcasts` — create (201) or answer the stored campaign of the same id (200). */
    create(input) {
        return this.client.request({ method: 'POST', path: '/v1/broadcasts', body: input, auth: true });
    }
    /** `GET /v1/broadcasts?market=`, `?region=` (a state's code: the campaigns reaching any of its markets) or `?country=` — the campaigns. */
    list(scope, opts = {}) {
        const base = 'market' in scope ? `market=${encodeURIComponent(scope.market)}` : 'region' in scope ? `region=${encodeURIComponent(scope.region)}` : `country=${encodeURIComponent(scope.country)}`;
        const q = opts.limit !== undefined ? `${base}&limit=${opts.limit}` : base;
        return this.client.request({ method: 'GET', path: `/v1/broadcasts?${q}`, auth: true });
    }
    /** `GET /v1/broadcasts/:id` — one campaign with its delivery progress. */
    get(campaignId) {
        return this.client.request({ method: 'GET', path: `/v1/broadcasts/${encodeURIComponent(campaignId)}`, auth: true });
    }
    /** `POST /v1/broadcasts/:id/cancel` — QUEUED/RUNNING → CANCELLED. */
    cancel(campaignId) {
        return this.client.request({ method: 'POST', path: `/v1/broadcasts/${encodeURIComponent(campaignId)}/cancel`, body: {}, auth: true });
    }
}
export class BannersApi {
    client;
    constructor(client) {
        this.client = client;
    }
    list(opts = {}) {
        const q = [opts.audience !== undefined ? `audience=${opts.audience}` : '', opts.includeExpired === true ? 'expired=1' : ''].filter((x) => x !== '').join('&');
        return this.client.request({ method: 'GET', path: `/v1/banners${q === '' ? '' : `?${q}`}`, auth: true });
    }
    create(input) {
        return this.client.request({ method: 'POST', path: '/v1/banners', body: input, auth: true });
    }
    update(bannerId, patch) {
        return this.client.request({ method: 'POST', path: `/v1/banners/${encodeURIComponent(bannerId)}`, body: patch, auth: true });
    }
    /** `GET /v1/banners/current` — the rider names the market he is in; a driver's is his own. */
    current(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/banners/current${marketId !== undefined ? `?market=${encodeURIComponent(marketId)}` : ''}`, auth: true });
    }
}
export class AwardsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    list(market, status) {
        return this.client.request({ method: 'GET', path: `/v1/awards?market=${encodeURIComponent(market)}${status !== undefined ? `&status=${status}` : ''}`, auth: true });
    }
    get(market, campaignId) {
        return this.client.request({ method: 'GET', path: `/v1/awards/${encodeURIComponent(campaignId)}?market=${encodeURIComponent(market)}`, auth: true });
    }
    propose(input) {
        return this.client.request({ method: 'POST', path: '/v1/awards', body: input, auth: true });
    }
    decide(market, campaignId, decision) {
        return this.client.request({ method: 'POST', path: `/v1/awards/${encodeURIComponent(campaignId)}/decision?market=${encodeURIComponent(market)}`, body: decision, auth: true });
    }
    end(market, campaignId) {
        return this.client.request({ method: 'POST', path: `/v1/awards/${encodeURIComponent(campaignId)}/end?market=${encodeURIComponent(market)}`, body: {}, auth: true });
    }
    /** `GET /v1/driver/awards` — the driver's own. */
    mine() {
        return this.client.request({ method: 'GET', path: '/v1/driver/awards', auth: true });
    }
    /** `POST /v1/driver/awards/grants/:id/seen` — the app showed the alert. */
    markSeen(grantId) {
        return this.client.request({ method: 'POST', path: `/v1/driver/awards/grants/${encodeURIComponent(grantId)}/seen`, body: {}, auth: true });
    }
}
//# sourceMappingURL=broadcast.js.map